import { jsx as _jsx } from "react/jsx-runtime";
import AiAssistantContainer from "src/features/aiAssistant/AiAssistantContainer";
const AiAssistantTab = () => {
    return _jsx(AiAssistantContainer, {});
};
export default AiAssistantTab;
